import { BlockOneshopUnauthenticatedRenewalPayment } from 'shared/api/client';
import { FormattedProps } from './types';

export default function propsFormatter(
  content: BlockOneshopUnauthenticatedRenewalPayment['content']
): FormattedProps {
  return {
    pending: {
      title: content.pending.title.label ?? null,
      titleHtmlTag: content.pending.title.htmlTag ?? null,
      content: content.pending.content
    },
    success: {
      title: content.success.title.label ?? null,
      titleHtmlTag: content.success.title.htmlTag ?? null,
      content: {
        ...content.success.content,
        cta: content.success.content.cta?.link
          ? {
              label: content.success.content.cta.label,
              href: content.success.content.cta.link.href
            }
          : null
      }
    },
    failure: {
      title: content.failure.title.label ?? null,
      titleHtmlTag: content.failure.title.htmlTag ?? null,
      content: {
        ...content.failure.content,
        cta: content.failure.content.cta?.link
          ? {
              label: content.failure.content.cta.label,
              href: content.failure.content.cta.link.href
            }
          : null
      }
    },
    apis: {
      getQrCodeRenewal:
        'crm_management_acts_qrcode_renewal' in content.apis
          ? {
              url: content.apis.crm_management_acts_qrcode_renewal?.url ?? '',
              method:
                content.apis.crm_management_acts_qrcode_renewal?.method ||
                'POST'
            }
          : null,
      getUpdatingOptionsOfferModification:
        'crm_management_acts_updating_options_offer_modification' in
        content.apis
          ? {
              url:
                content.apis
                  ?.crm_management_acts_updating_options_offer_modification
                  .url ?? '',
              method: 'POST'
            }
          : null,
      getQrCodeOrderStatus: {
        url: content.apis.crm_management_acts_qrcode_orderstatus?.url ?? '',
        method:
          content.apis.crm_management_acts_qrcode_orderstatus?.method || 'GET'
      }
    }
  };
}
